import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '../../lib/nav';
import { useFeatures } from '../../context/FeatureContext';
import { AppContext } from '../../context/AppContext';
import { cn } from '../../lib/utils';

// Apple-app-style bottom tab bar for narrow screens. Same NAV_ITEMS as the
// desktop sidebar, so the two can never drift.
export default function MobileTabBar() {
  const location = useLocation();
  const { isFeatureEnabled, loading } = useFeatures();
  const { isConnected } = useContext(AppContext);

  const items = loading
    ? []
    : NAV_ITEMS.filter((item) => !item.feature || isFeatureEnabled(item.feature));

  if (items.length === 0) return null;

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/80 backdrop-blur-xl md:hidden safe-area-inset-bottom">
      <div className="mx-auto flex max-w-md items-center justify-around px-1 py-1.5">
        {items.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          const badge = item.id === 'settings' && !isConnected;
          return (
            <Link
              key={item.id}
              to={item.path}
              aria-current={active ? 'page' : undefined}
              className={cn(
                'relative flex min-w-0 flex-1 flex-col items-center gap-0.5 rounded-2xl px-2 py-1.5 transition-colors',
                active ? 'text-primary' : 'text-muted-foreground'
              )}
            >
              <span className="relative">
                <Icon className="h-[22px] w-[22px]" strokeWidth={active ? 2.25 : 2} />
                {badge && <span className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-destructive" />}
              </span>
              <span className="truncate text-[10px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
